import { defineStore } from 'pinia';
import ReportService from '../service/ReportService.js';
const reportService = new ReportService();

export const useReportStore = defineStore({
    id: 'report',
    state: () => ({
        pdfs: null,
        snapshots: null,
        error: null,
    }),
    getters: {
        getPdfs: (state) => {
            return state.pdfs;
        },
        getSnapshots: (state) => {
            return state.snapshots;
        },
        getError: (state) => {
            return state.error;
        }
    },
    actions: {
        setPdfs(pdfs) {
            this.pdfs = pdfs;
        },

        async fetchSnapshotList(date = null, hour = null) {
            this.loading = true;
            try {
                return await reportService.fetchSnapshots(date, hour)
                    .then((response) => {
                        let elements = [];
                        // dir initialization
                        if (date === null && hour === null) {

                            if (response.items === undefined)
                                return;

                            for (let i = 0; i < response.items.length; i++) {
                                elements.push({
                                    key: i,
                                    data: { date: response.items[i] },
                                    leaf: false
                                });
                            }

                            // this.snapshots.count = response.count;
                            this.snapshots = elements;

                        } else if (hour === null) { // table update
                            let children = [];
                            for (let i = 0; i < response.items.length; i++) {
                                children.push({
                                    data: {
                                        parent: date,
                                        name: response.items[i].name,
                                        start: response.items[i].start,
                                        end: response.items[i].end,
                                        category: response.items[i].category,
                                    },
                                });
                            }

                            for (let i = 0; i < this.snapshots.length; i++) {
                                if (this.snapshots[i].data.date === date) {
                                    this.snapshots[i].children = children;
                                }
                            }
                        } else { // single snapshot
                            return response;
                        }
                    })

            } catch (error) {
                this.error = error;
            } finally {
                this.loading = false;
            }
        },

        async fetchPdfList() {
            this.loading = true;
            try {
                this.pdfs = await reportService.fetchPdfs()
                    .then((response) => response)
            } catch (error) {
                this.error = error
            } finally {
                this.loading = false
            }
        },
        async deleteSnapshot(node) {
            this.loading = true;
            try {
                return await reportService.deleteSnapshot(node)
                    .then(response => {
                        if (response.status === 200) {
                            // remove snapshot
                            for (let i = 0; i < this.snapshots.length; i++) {
                                if (this.snapshots[i].data.date === node.parent) {
                                    this.snapshots[i].children = this.snapshots[i].children.filter(item => {
                                        if (item.data.name !== node.name)
                                            return item;
                                    });

                                    // remove snapshot father if it's empty
                                    if (this.snapshots[i].children.length === 0)
                                        this.snapshots.splice(i, 1);
                                }
                            }
                        }
                        return response;
                    });

            } catch (error) {
                this.error = error;
            } finally {
                this.loading = false;
            }
        },
        async downloadPdf(uri) {
            this.loading = true;
            try {
                this.download = await reportService.downloadPdf(uri)
                    .then((response) => response)
            } catch (error) {
                this.error = error
            } finally {
                this.loading = false
            }
        }
    }
})
